<template>

  <div id="app">

        <div class="col-12 bg-header">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-2 text-center">
                <a href="https://www.rueden.de/"><img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/></a>
              </div>
              <div class="col-12 col-md-8 text-center">
                <h1>Beitragsanpassung Private Krankenversicherung</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="container pt-5 pb-5 mb-5" v-if="schritt === 1">

          <form id="form_1">
            <Schrittanzeige :schritt="schritt" :erhoehung="true" />
            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2">
                <div class="formular-box">

                  <div class="row">
                    <div class="col-12">
                      <h2 class="mt-0 pt-0 mb-0 pb-5">1. Fragen zu Ihrer Versicherung</h2>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-12">
                      <div class="rueden-input">
                        <label>Bei welcher Krankenversicherung sind Sie versichert?</label>
                        <vue-simple-suggest @select="updatePKV"
                                            :list="pkv_synonyme"
                                            :min-length="1"
                                            :max-suggestions="0"
                                            :filter-by-query="true">
                          <input
                              class="form-control"
                              v-model="pkv_name"
                              type="text"
                              required
                              @focus="sendGaEvent"
                              @change="sendGaEvent"
                              name="pkv_name"
                              autocomplete="off"
                          />
                          </vue-simple-suggest>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-7 col-xl-8 pr-0">
                      <p class="form-question">
                        Wurden Ihre Beiträge in der Vergangenheit erhöht oder eine Beitragsanpassung angekündigt?
                      </p>
                    </div>
                    <div class="col-12 col-md-5 col-xl-4 text-right mobile-md-text-left">
                      <div class="form-checkboxes form-display-inline">
                        <input @change="sendGaEvent" type="radio" id="beitragserhoehung_ja" value="Ja" v-model="beitragserhoehung" name="beitragserhoehung" required/>
                        <label for="beitragserhoehung_ja">Ja</label>
                      </div>
                      <div class="form-checkboxes form-display-inline">
                        <input @change="sendGaEvent" type="radio" id="beitragserhoehung_nein" value="Nein" v-model="beitragserhoehung" name="beitragserhoehung" required/>
                        <label for="beitragserhoehung_nein">Nein</label>
                      </div>
                    </div>
                  </div>


                  <div v-if="beitragserhoehung == 'Ja'">

                      <div class="row">
                        <div class="col-12 col-md-7 col-xl-8 pr-0">
                          <p class="form-question">
                            Sind oder waren Sie innerhalb der letzten 10 Jahre bei einer oder mehreren Rechtsschutzversicherungen versichert?
                          </p>
                        </div>
                        <div class="col-12 col-md-5 col-xl-4 text-right mobile-md-text-left">
                          <div class="form-checkboxes form-display-inline">
                            <input @change="sendGaEvent" type="radio" id="has_rsv_ja" value="Ja" v-model="has_rsv" name="has_rsv" required/>
                            <label for="has_rsv_ja">Ja</label>
                          </div>
                          <div class="form-checkboxes form-display-inline">
                            <input @change="sendGaEvent" type="radio" id="has_rsv_nein" value="Nein" v-model="has_rsv" name="has_rsv" required/>
                            <label for="has_rsv_nein">Nein</label>
                          </div>
                        </div>
                      </div>

                      <div v-if="has_rsv == 'Ja'">
                        <div class="row">
                          <div class="col-12">
                            <div class="rueden-input">
                              <label>Wie lauten die Namen Ihrer Rechtsschutzversicherungen?</label>
                              <vue-simple-suggest @select="updateRSV($event,0);"
                                                  :list="rsv_synonyme"
                                                  :min-length="1"
                                                  :max-suggestions="0"
                                                  :filter-by-query="true">
                                <input
                                       class="form-control"
                                       name="rsv_1"
                                       v-model="rsv[0]"
                                       type="text"
                                       required
                                       @focus="sendGaEvent"
                                       @change="sendGaEvent"
                                />
                              </vue-simple-suggest>

                              <div class="pt-2">
                                <a type="button" @click.prevent="show_more_rsv = !show_more_rsv;sendGaEvent($event);" name="weitere-Versicherungen" class="show-more-click"><i style="font-size: 12px" class="fa fa-plus"></i>&nbsp; weitere Versicherungen hinzufügen </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="show_more_rsv == true">

                          <!-- weitere optionale angaben zu mehrfachen rsv-->
                          <div class="row">
                            <div class="col-12 col-md-6">
                              <div class="rueden-input">
                                <vue-simple-suggest @select="updateRSV($event,1)"
                                                    :list="rsv_synonyme"
                                                    :min-length="1"
                                                    :max-suggestions="0"
                                                    :filter-by-query="true">
                                  <input
                                         class="form-control"
                                         name="rsv_2"
                                         v-model="rsv[1]"
                                         type="text"
                                         placeholder="(optional)"
                                         @focus="sendGaEvent"
                                         @change="sendGaEvent"
                                  />
                                </vue-simple-suggest>
                              </div>
                            </div>
                            <div class="col-12 col-md-6">
                              <div class="rueden-input">
                                <vue-simple-suggest @select="updateRSV($event,2)"
                                                    :list="rsv_synonyme"
                                                    :min-length="1"
                                                    :max-suggestions="0"
                                                    :filter-by-query="true">
                                  <input
                                         class="form-control"
                                         name="rsv_3"
                                         v-model="rsv[2]"
                                         type="text"
                                         placeholder="(optional)"
                                         @focus="sendGaEvent"
                                         @change="sendGaEvent"
                                  />
                                </vue-simple-suggest>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-md-6">
                              <div class="rueden-input">
                                <vue-simple-suggest @select="updateRSV($event,3)"
                                                    :list="rsv_synonyme"
                                                    :min-length="1"
                                                    :max-suggestions="0"
                                                    :filter-by-query="true">
                                  <input
                                         class="form-control"
                                         name="rsv_4"
                                         v-model="rsv[3]"
                                         type="text"
                                         placeholder="(optional)"
                                         @focus="sendGaEvent"
                                         @change="sendGaEvent"
                                  />
                                </vue-simple-suggest>
                              </div>
                            </div>
                            <div class="col-12 col-md-6">
                              <div class="rueden-input">
                                <vue-simple-suggest @select="updateRSV($event,4)"
                                                    :list="rsv_synonyme"
                                                    :min-length="1"
                                                    :max-suggestions="0"
                                                    :filter-by-query="true">
                                  <input
                                         class="form-control"
                                         name="rsv_5"
                                         v-model="rsv[4]"
                                         type="text"
                                         placeholder="(optional)"
                                         @focus="sendGaEvent"
                                         @change="sendGaEvent"
                                  />
                                </vue-simple-suggest>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <!--
                      <div class="row">
                        <div class="col-12 text-center mt-2">
                          <div class="alert alert-info mb-4">
                            <span class="text-left hinweis-text-block pkv-hinweis m-0"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Um Ihre Ansprüche qualifiziert prüfen zu können, benötigen wir noch zusätzliche Informationen von Ihnen sowie Ihre Kontaktdaten. Wir holen anschließend <strong>kostenlos</strong> bei Ihrer Versicherung alle relevanten Informationen zu früheren Beitragsanpassungen ein.</span>
                          </div>
                        </div>
                      </div>
                    -->

                  </div>

                  <div v-if="beitragserhoehung == 'Nein'">
                    <div class="row">
                      <div class="col-12 text-center mt-2">
                        <div class="alert alert-info mb-4 m-0">
                          <span class="text-left hinweis-text-block pkv-hinweis m-0"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Da Ihre Beiträge nicht angepasst wurden, können wir Ihnen diesbezüglich leider nicht weiterhelfen. Wir beraten Sie aber gerne <b>kostenlos</b> zu günstigeren Alternativen zu Ihrer Krankenversicherung.</span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-12 mt-4">
                      <button name="to-step-2" type="submit" @click.prevent="sendGaEvent($event);nextStep();" class="btn btn-primary-blue float-right">
                        weiter &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </form>

        </div>

        <div class="container pt-5 pb-5 mb-5" v-if="schritt === 2">

          <form id="form_2">
            <Schrittanzeige :schritt="schritt" :erhoehung="beitragserhoehung != 'Nein'" />
            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2">
                <div class="formular-box">

                  <div class="row">
                    <div class="col-12">
                      <h2 class="mt-0 pt-0 mb-0 pb-5">2. Ihre Kontaktdaten</h2>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-checkboxes form-display-inline">
                        <input @change="sendGaEvent" type="radio" id="woman" value="Frau" v-model="anrede" name="anrede" required/>
                        <label for="woman" class="">Frau</label>
                      </div>
                      <div class="form-checkboxes form-display-inline">
                        <input @change="sendGaEvent" id="men" type="radio" value="Herr" v-model="anrede" name="anrede" required/>
                        <label for="men" class="">Herr</label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="rueden-input">
                        <label>Vorname</label>
                        <input @focus="sendGaEvent" @change="sendGaEvent" class="form-control" type="text" v-model="vorname" name="vorname" required/>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="rueden-input">
                        <label>Nachname</label>
                        <input @focus="sendGaEvent" @change="sendGaEvent" class="form-control" type="text" v-model="nachname" name="nachname" required/>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12"
                         :class="{'col-md-9' : this.address_missingNo }">
                      <div class="rueden-input">
                        <label v-bind:class="{ 'text-danger' : address_empty }">Straße, Ort</label>

                        <vue-google-autocomplete
                            id="address_google"
                            ref="addressGoogle"
                            classname="form-control"
                            placeholder=""
                            types="address"
                            v-on:placechanged="getAddressData"
                            v-on:blur="blurGetAddressData"
                            :country="['de','ch','at']"
                            v-model="address_google"
                            v-on:focus="sendGAfromAutocomplete"
                        >
                        </vue-google-autocomplete>
                        <input class="form-control d-none" type="text" v-model="strasse" name="strasse" required/>
                        <small style="line-height: 1; color: rgb(134, 134, 134)" v-bind:class="{ 'text-danger' : address_empty }"> Wählen Sie bitte eine der Adressen aus.</small>
                        <!--<small style="line-height: 1" class="text-danger" v-if="address_missingNo && !address_empty">Bitte geben Sie
                          eine Hausnummer an.</small>
                        -->
                      </div>
                    </div>

                    <div class="row d-none">
                      <div class="col-4">
                        <div class="rueden-input">
                          <label>PLZ</label>
                          <input ref="address_plz" class="form-control" type="text" v-model="plz"
                                 name="plz" required/>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="rueden-input">
                          <label>Ort</label>
                          <input class="form-control" type="text" v-model="ort" name="ort" required/>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="rueden-input">
                          <label>Land</label>
                          <input ref="land" class="form-control" type="text" v-model="land"
                                 name="land" required/>
                        </div>
                      </div>
                    </div>

                    <div v-if="address_missingNo" class="col-12 col-md-3">
                      <div class="rueden-input">
                        <label>Nr.</label>
                        <input ref="streetNumber" @focus="sendGaEvent" @change="setStreetNumber();sendGaEvent($event)" class="form-control" type="text" v-model="strasse_nummer" name="strasse_nummer" required/>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="rueden-input">
                        <label>E-Mail</label>
                        <input @focus="sendGaEvent" @change="sendGaEvent" class="form-control" type="email" v-model="email" name="email" required/>
                      </div>
                    </div>
                  </div>

                  <div v-if="beitragserhoehung == 'Ja'" class="row">
                    <div class="col-12 text-center mt-2">
                      <div class="alert alert-info mb-4">
                        <span class="text-left hinweis-text-block pkv-hinweis m-0"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                          Um Ihre Ansprüche qualifiziert prüfen zu können, benötigen wir Ihre Kontaktdaten. Wir holen <strong>kostenlos</strong> bei Ihrer Versicherung alle relevanten Informationen zu früheren Beitragsanpassungen ein und berechnen damit Ihre Ansprüche.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-else class="row">
                    <div class="col-12 text-center mt-2">
                      <div class="alert alert-info mb-4">
                        <span class="text-left hinweis-text-block pkv-hinweis m-0"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Bitte tragen Sie Ihre Kontaktdaten ein, damit wir Sie <strong>kostenlos</strong> über Alternativen zu Ihrer Krankenversicherung informieren können.</span>
                      </div>
                    </div>
                  </div>

                  <div class="row">

                    <div class="col-12">
                      <div class="form-checkboxes form-display-inline">
                        <input @change="sendGaEvent" type="checkbox" id="vollmachtFirstCheck"
                               v-model="zustimmung_datenschutz_und_widerruf" name="zustimmung_datenschutz_und_widerruf" required/>
                        <label for="vollmachtFirstCheck">Ich habe die <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
                          und die <a href="#" v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</a> gelesen und bin
                          damit einverstanden.</label>
                      </div>
                    </div>

                  </div>




                  <div class="row">
                    <div class="col-12 col-sm-6 mt-4">
                      <button name="back-to-step-1" class="btn btn-secondary" @click.prevent="stepBack();sendGaEvent($event);">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i> &nbsp; zurück
                      </button>
                    </div>
                    <div class="col-12 col-sm-6 mt-4">
                      <button name="final-submit" class="btn btn-primary-blue float-right" @click.prevent="createLead()">
                        Kostenlos beauftragen &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </form>

        </div>

        <div class="container pt-5 pb-5 mb-5" v-if="schritt === 3">
          <Schrittanzeige :schritt="schritt" :erhoehung="beitragserhoehung != 'Nein'" />

          <div class="row mb-5">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">
                <div class="row">
                  <div class="col-12 text-center">
                    <div class="alert alert-info">
                      <h2 class="mt-0 pt-0 mb-0 pt-2 pb-4">Vielen Dank für Ihren Auftrag!</h2>
                      <p style="font-weight: normal" v-if="beitragserhoehung == 'Ja'" class="lead">Wir bereiten nun das Anschreiben an Ihre Krankenversicherung vor und informieren Sie jeweils über den Zwischenstand. Eine Antwort der Versicherung dauert in aller Regel bis zu 3 Wochen.</p>
                      <p style="font-weight: normal" v-else class="lead">Wir melden uns zeitnah bei Ihnen, um Sie <strong>kostenlosen</strong> zu Alternativen zu Ihrer Krankenversicherung zu beraten.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="col-12 mb-4">
          <div class="container">
            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2 text-center text-secondary">
                &copy; 2020 - VON RUEDEN Partnerschaft von Rechtsanwälten<br />
                <b-link v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</b-link> &middot; <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Modals -->
        <Datenschutzerklaerung/>
        <Widerrufsbelehrung/>

  </div>

</template>
<script>

import Schrittanzeige from '../../components/pkv/Schrittanzeige'
import VueSimpleSuggest from 'vue-simple-suggest'
import Datenschutzerklaerung from '../Datenschutzerklaerung'
import Widerrufsbelehrung from '../Widerrufsbelehrung'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import axios from "axios";

export default {

  components: {Schrittanzeige, Datenschutzerklaerung, Widerrufsbelehrung, VueGoogleAutocomplete, VueSimpleSuggest},

  data() {
    return {

      // Schritt
      schritt: 1,
      //Formular
      anrede: null,
      vorname: null,
      nachname: null,
      pkv_name: null,
      beitragserhoehung: null,
      kostenlos_anfragen: null,
      beratung_alternativen: null,
      email: null,
      land: null,
      strasse: null,
      strasse_nummer: null,
      plz: null,
      address_google: null,
      address_empty: false,
      address_missingNo: true,
      ort: null,

      has_rsv: null,
      show_more_rsv: false,
      rsv: [],

      zustimmung_datenschutz_und_widerruf: null,
      token: null
    }
  },
  mounted() {
    this.pkv_name = this.$route.query.pkv;
    document.title = 'Private Krankenversicherung - Fragebogen';
  },
  methods: {
    //Schrittzähler
    validateForm(id) {
      let form = document.getElementById("form_" + id);
      let isValid = form.checkValidity();
      if (!isValid) form.reportValidity();
      return isValid;
    },
    nextStep() {
      if (this.validateForm(this.schritt)) {
        this.schritt += 1;
      }
    },
    stepBack() {
      if (this.schritt > 1) this.schritt -= 1;
    },
    setStreetNumber() {
      if (this.strasse_nummer) {
        this.strasse = this.strasse + ' ' + this.strasse_nummer;
        this.setGoogleAddress();
        this.$refs.addressGoogle.$el.value = this.address_google;
        this.address_missingNo = false;
        if (!this.plz && this.strasse && this.ort && this.land) {
          var _this = this;
          var service = new window.google.maps.places.AutocompleteService();
          service.getPlacePredictions({ input: this.address_google, types: ['address'] }, function(predictions){
            var pID = predictions[0].place_id;
            var service2 = new window.google.maps.places.PlacesService(document.createElement('address_google'));
            service2.getDetails({fields:['address_components'], placeId:pID}, function(r) {
              r.address_components.forEach(function(c) {
                if (c.types.includes('postal_code')) {
                  _this.plz = c.long_name;
                  _this.setGoogleAddress();
                  _this.$refs.addressGoogle.$el.value = _this.address_google;
                }
              });
            });
          });
        }
      }
    },
    getAddressData: function (addressData) {
      this.address_empty = false;
      this.land = addressData.country;
      this.ort = addressData.locality;
      if (addressData.postal_code) this.plz = addressData.postal_code;
      if (addressData.street_number) {
        this.strasse_nummer = addressData.street_number;
        this.strasse = addressData.route  + ' ' + this.strasse_nummer;
        this.address_missingNo = false;
      } else {
        this.strasse_nummer = null;
        this.strasse = addressData.route;
        setTimeout(() => {
          this.$refs.streetNumber.focus();
        });
        this.address_missingNo = true;
      }
      this.setGoogleAddress();
      this.$refs.addressGoogle.$el.value = this.address_google;
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      //Google Analytics
      this.$gtag.event('change', {
        'event_category': devPrefix + "PkV Formular",
        'event_label': "google-address (text)"
      });
       // this.$ga.event(
       //   devPrefix + "PkV Formular",
       //   "change",
       //   "google-address (text): "+this.address_google
       // );
    },
    setGoogleAddress() {
      let prevAddress = this.strasse;
      if (this.ort) {
        if (this.plz) {
          prevAddress = prevAddress + ", " + this.plz + " " + this.ort;
        } else {
          prevAddress = prevAddress + ", " + this.ort;
        }
      }
      prevAddress = prevAddress + ", " + this.land;
      this.address_google = prevAddress;
    },
    blurGetAddressData() {
      if (
          !this.strasse
          || !this.ort
      ) {
        this.address_empty = true;
        this.$refs.addressGoogle.$el.value = "";
      } else {
        this.setGoogleAddress();
        this.$refs.addressGoogle.$el.value = this.address_google;
      }
    },
    clearAddressFields() {
      this.plz = null;
      this.strasse = null;
      this.ort = null;
      this.strasse_nummer = null;
      // this.address_missingNo = false; // rausnehmen
    },
    createLead() {
      this.blurGetAddressData();
      if (this.validateForm(this.schritt) && !this.address_empty /*&& !this.address_missingNo*/) {
        let formData = new FormData();
        for (const [key, value] of Object.entries(this.$data)) {
          formData.append(key, value);
        }
        axios.post("https://flow.rueden.de/api/add/lead/pkv",
            formData,
        ).then(function (response) {
          console.log(response.data);
        });
        this.schritt += 1;

        let devPrefix = "";
        if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
        //Google Analytics
        this.$gtag.event('Formular abgeschickt', {
          'event_category': devPrefix + "PkV Formular",
          'event_label': "Formular"
        });
         // this.$ga.event(
         //   devPrefix + "PkV Formular",
         //   "Formular abgeschickt",
         //   "Formular"
         // );

        setTimeout(function(){
          console.log("VON RUEDEN");
          window.location.href = "https://rueden.de";
        }, 10000);
      }
    },
    pkv_synonyme() {
      return axios.get('https://flow.rueden.de/api/get/all-pkv')
          .then(response => {
            return response.data[0];
          });
    },
    updatePKV(pkv) {
      this.pkv_name = pkv;
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      //Google Analytics
      this.$gtag.event('change', {
        'event_category': devPrefix + "PkV Formular",
        'event_label': "pkv_name (text)"
      });
       // this.$ga.event(
       //   devPrefix + "PkV Formular",
       //   "change",
       //   "pkv_name (text): \""+pkv+"\""
       // );
    },
    rsv_synonyme() {
      return axios.get('https://flow.rueden.de/api/get/all-rsv')
          .then(response => {
            return response.data[0];
          });
    },
    updateRSV(rsv,i) {
      this.rsv[i] = rsv;
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      //Google Analytics
      this.$gtag.event('change', {
        'event_category': devPrefix + "PkV Formular",
        'event_label': "rsv_"+i+" (text)"
      });
      //  this.$ga.event(
      //    devPrefix + "PkV Formular",
      //    "change",
      //    "rsv_"+i+" (text): \""+rsv+"\""
      //  );
    },
    //Google Analytics Tracking
    sendGAfromAutocomplete() {
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      this.$gtag.event('focus', {
        'event_category': devPrefix + "PkV Formular",
        'event_label': "google-address (text)"
      });
       // this.$ga.event(
       //   devPrefix + "PkV Formular",
       //   "focus",
       //   "google-address (text)"
       // );
    },
    sendGaEvent($event) {
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      let label = $event.target.name+" ("+$event.target.type+")";
      // if ($event.type === "change") label = label + ": \""+$event.target.value+"\"";
      this.$gtag.event($event.type, {
        'event_category': devPrefix + "PkV Formular",
        'event_label': label
      });
       // this.$ga.event(
       //   devPrefix + "PkV Formular",
       //   $event.type,
       //   label
       // );
    }

  },
  computed: {

  }
}
</script>
